/* src/app/shared/components/responsive-table/responsive-table.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.responsive-table {
  width: 100% !important;
  position: relative;
}
::ng-deep table.dataTable > tbody > tr.child ul.dtr-details {
  width: 100%;
}
::ng-deep table.dataTable > tbody > tr.child span.dtr-title {
  min-width: 7.5rem;
}
::ng-deep table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > td:first-child:before,
::ng-deep table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > th:first-child:before {
  top: -1px;
  left: 0;
  color: #242424;
  border: none;
  background-color: transparent;
  font-size: 2em;
  box-shadow: none;
  position: relative;
}
::ng-deep .mat-mdc-button.actions {
  padding: 0;
  min-width: 0;
  width: 3em;
  height: 3em;
  border-radius: 50%;
}
::ng-deep .row-actions .buttons-menu {
  display: flex;
  text-align: center;
}
@media screen and (min-width: 64rem) {
  ::ng-deep .row-actions .buttons-menu {
    display: none;
  }
}
@media screen and (min-width: 64rem) {
  ::ng-deep .row-actions .buttons-menu.always {
    display: flex;
  }
}
::ng-deep .row-actions .buttons-explicit {
  display: none;
}
@media screen and (min-width: 64rem) {
  ::ng-deep .row-actions .buttons-explicit {
    display: flex;
    flex-wrap: wrap;
  }
}
@media screen and (min-width: 64rem) {
  ::ng-deep .row-actions .buttons-explicit.never {
    display: none;
  }
}
::ng-deep .action-item.mat-mdc-raised-button {
  padding: 0 1em;
  margin: 0.25em 0.5em;
  min-width: initial;
  line-height: 2.5em;
}
::ng-deep .action-item.mat-mdc-raised-button .mat-button-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.8em;
}
::ng-deep .action-item.mat-mdc-raised-button .mat-button-wrapper span {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 0.25em;
}
::ng-deep .action-item.mat-mdc-raised-button .mat-button-wrapper span.icon .mat-icon {
  font-size: 1.75em;
  height: 20px;
  width: 20px;
  line-height: 1.1;
}
::ng-deep .action-item.mat-mdc-raised-button .mat-button-wrapper span.text {
  justify-content: flex-start;
}
/*# sourceMappingURL=responsive-table.component.css.map */
